import type { z } from "zod";
import { createContext, useContext } from "react";
import type { partialCraftSchema } from "@/schemas/craft/create";

interface CraftContextType {
    onFirstStepComplete: (data: z.infer<typeof partialCraftSchema>) => void,
    onSecondStepComplete: (data: z.infer<typeof partialCraftSchema>) => void,
    onLayoutStepComplete: (data: z.infer<typeof partialCraftSchema>) => void,
    onThirdStepComplete: (data: z.infer<typeof partialCraftSchema>) => void,
    onFourthStepComplete: (data: z.infer<typeof partialCraftSchema>) => void,
    onTycStepComplete: (data: z.infer<typeof partialCraftSchema>) => void,
    onFifthStepComplete: (file: File | null) => void,
    isFetching: boolean
}

export const CraftContext = createContext<CraftContextType | null>(null);

export const useCraftContext = () => {
    const context = useContext(CraftContext);
    if (!context) {
        throw new Error("useCraftContext must be used within a CraftContextProvider");
    }
    return context;
}